import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import { Box, IconButton, Typography } from '@mui/material';
import React, { FC } from 'react';
import strings from '../../../../../../common/Translation/Translate';
import { VenueConfigEmptyState } from '../../VenueConfigEmptyState';
import { VenueConfigSectionAction } from '../../VenueConfigSectionAction';
import {
  venueConfigDeleteIconProps,
  venueConfigTableDataRowSx,
  venueConfigTableHeaderCellSx,
  venueConfigTableHeaderRowSx,
  venueConfigTableShellSx,
} from '../../venueConfigTableStyles';
import { formatUnavailabilityDisplayDate, UnavailabilityDateRange } from './unavailabilityDateUtils';

type UnavailabilityDateListProps = {
  dates: UnavailabilityDateRange[];
  onAdd: () => void;
  onEdit: (index: number) => void;
  onDelete: (index: number) => void;
};

export const UnavailabilityDateList: FC<UnavailabilityDateListProps> = ({
  dates,
  onAdd,
  onEdit,
  onDelete,
}) => (
  <Box
    sx={{
      border: 1,
      borderColor: 'divider',
      borderRadius: 2,
      p: 2,
      bgcolor: 'background.paper',
      height: '100%',
    }}>
    <Typography variant="subtitle1" fontWeight={600} gutterBottom>
      {strings.venueConfig_unavailability_dates_title}
    </Typography>
    <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
      {strings.venueConfig_unavailability_dates_hint}
    </Typography>
    <Box sx={{ mb: 1.5 }}>
      <VenueConfigSectionAction label={strings.unavailable_date} onClick={onAdd} />
    </Box>
    {dates.length === 0 ? (
      <VenueConfigEmptyState message={strings.venueConfig_unavailability_dates_empty} />
    ) : (
      <Box sx={venueConfigTableShellSx}>
        <Box sx={venueConfigTableHeaderRowSx}>
          <Typography {...venueConfigTableHeaderCellSx} sx={{ flex: 1, minWidth: 140 }}>
            {strings.venueConfig_general_unavailabilityStart}
          </Typography>
          <Typography {...venueConfigTableHeaderCellSx} sx={{ flex: 1, minWidth: 140 }}>
            {strings.venueConfig_general_unavailabilityEnd}
          </Typography>
          <Box sx={{ width: 80, flexShrink: 0 }} />
        </Box>
        {dates.map((range, index) => (
          <Box key={range.id ?? `unavailability-${index}`} sx={venueConfigTableDataRowSx}>
            <Typography variant="body2" sx={{ flex: 1, minWidth: 140 }}>
              {formatUnavailabilityDisplayDate(range.unavailabilityStartDate)}
            </Typography>
            <Typography variant="body2" sx={{ flex: 1, minWidth: 140 }}>
              {formatUnavailabilityDisplayDate(range.unavailabilityEndDate)}
            </Typography>
            <Box sx={{ width: 80, flexShrink: 0, display: 'flex', justifyContent: 'flex-end' }}>
              <IconButton size="small" aria-label="edit" onClick={() => onEdit(index)}>
                <EditOutlinedIcon fontSize="small" />
              </IconButton>
              <IconButton
                size="small"
                aria-label="delete"
                onClick={() => onDelete(index)}
                {...venueConfigDeleteIconProps}>
                <DeleteOutlineOutlinedIcon fontSize="small" />
              </IconButton>
            </Box>
          </Box>
        ))}
      </Box>
    )}
  </Box>
);
